import React from 'react';


// Start Main
import Header from './components/main/Header';
import Footer from './components/main/Footer';
import { Route, Routes } from 'react-router-dom';

// Start Pages
import Home from './components/pages/Home';
import Services from './components/pages/Services';
import Portfolio from './components/pages/Portfolio';
import Contact from './components/pages/Contact';
import Booking from './components/pages/Booking';
import Events from './components/pages/Events';
import EventImages from './components/pages/EventImages';

// Start Sections
import ImagesSection from './components/section/ImagesSection';


// Start Hooks
import Top from './components/Top';
import ScrollToTop from './components/ScrollToTop';
import UseScrollAnimation from './hooks/UseScrollAnimation';

const App = () => {
    return (
        <>

            <Header />
            <Top />

            <Routes>
                <Route path='/' element={<Home />} />
                <Route path='/services' element={<Services />} />
                <Route path='/portfolio' element={<Portfolio />} />
                <Route path='/contact' element={<Contact />} />
                <Route path='/booking' element={<Booking/>} />
                <Route path='/events' element={<Events/>} />
                <Route path='/event-images/:id' element={<EventImages/>} />
            </Routes>

            <ImagesSection />
            <Footer />
            <ScrollToTop />
            <UseScrollAnimation />

        </>
    );
};

export default App;
